var exports = {
  "full-height": "x1cb7f6e3--ddc95a--full-height",
  "container": "x1cb7f6e3--ddc95a--container",
  "desktop": "x1cb7f6e3--ddc95a--desktop",
  "content": "x1cb7f6e3--ddc95a--content",
  "pages": "x1cb7f6e3--ddc95a--pages",
  "media-stack": "x1cb7f6e3--ddc95a--media-stack",
  "page": "x1cb7f6e3--ddc95a--page",
  "media-layer": "x1cb7f6e3--ddc95a--media-layer",
  "page-active": "x1cb7f6e3--ddc95a--page-active",
  "media-layer-active": "x1cb7f6e3--ddc95a--media-layer-active",
  "pages-animated": "x1cb7f6e3--ddc95a--pages-animated",
  "image": "x1cb7f6e3--ddc95a--image",
  "image-placeholder": "x1cb7f6e3--ddc95a--image-placeholder",
  "page-title": "x1cb7f6e3--ddc95a--page-title",
  "description": "x1cb7f6e3--ddc95a--description",
  "list": "x1cb7f6e3--ddc95a--list",
  "rates-list": "x1cb7f6e3--ddc95a--rates-list",
  "footer": "x1cb7f6e3--ddc95a--footer",
  "footer-desktop": "x1cb7f6e3--ddc95a--footer-desktop",
  "footer-side": "x1cb7f6e3--ddc95a--footer-side",
  "footer-side-right": "x1cb7f6e3--ddc95a--footer-side-right",
};

module.exports = exports;
